
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { IDeleteDataResponseAndPayload, TResponse, TResponseWithQData } from "../../../types/common";
import { IRecipientsListResponse } from '../../../types/api/recipients';


export async function saveRecipients(data: IRecipientsListResponse): Promise<AxiosResponse<TResponse<IRecipientsListResponse>>> {
    return axios.post<TResponse<IRecipientsListResponse>>(API_ENDPOINTS.RECIPIENTS_SAVE, data)
}

export async function listRecipients(qData: QData): Promise<AxiosResponse<TResponseWithQData<IRecipientsListResponse[]>>> {
    return axios.get(API_ENDPOINTS.RECIPIENTS_LIST, {
        params: qData
    })
}

export async function deleteRecipients(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.RECIPIENTS_DELETE, data)
}

export async function recipientsDetails(id:string): Promise<AxiosResponse<TResponse<IRecipientsListResponse>>> {
    return axios.get(`${API_ENDPOINTS.RECIPIENTS_DETAILS}/${id}`)
}

